export const hasValue = <T>(valueToCheck: T): valueToCheck is NonNullable<T> => {
  return valueToCheck !== null && valueToCheck !== undefined;
};